import React from 'react'
const ManagementItem = ({item}) => {
  return (
    <>
        <div key={item._id} className="management-page-member-wrap">
                <div className="management-page-member-info">
                    <div className="management-page-member-image">
                        <img src={item.img} alt="" />
                    </div>
                    <div className="management-page-member-line"></div>
                    <div className="management-page-member-name">
                        <p>{item.name}</p>
                    </div>
                    <div className="management-page-member-department">
                        <p>{item.department}</p>
                    </div>
                </div>
                <div className="management-page-member-biography">
       
                        <div className="biography-text1">
                        <p>{item.text1}</p>
                        </div>
                        <div className="biography-text2">
                            <p></p>
                            <p>{item.text2}</p>
                        </div>

                    
                </div>
                </div>
    </>
  )
}

export default ManagementItem

